export default {
  key: process.env.VUE_APP_PCA_API_KEY
}
